import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import styles from './styles.module.scss';
import clsx from 'clsx';

type Props = BaseButtonProps & {
    isSelected?: boolean;
    icon?: React.ReactNode;
};
export const ZoomControlButton = ({ children, isSelected, icon, className, ...props }: Props) => {
    return (
        <BaseButton {...props} className={clsx(styles['zoom-control-button'], isSelected && styles['zoom-control-button--selected'], className && className)}>
            {icon && <span className={styles['zoom-control-button__icon']}>{icon}</span>}
            {children && <span className={styles['zoom-control-button__text']}>{children}</span>}
        </BaseButton>
    );
};
